import { setCreateSection, setCreateStep } from '@/store/actions';
import { storySelector } from '@/store/selectors';
import { Box, Modal, IconButton, Typography, Theme, useMediaQuery } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const templates = [
  {
    title: 'Life Story',
    text: 'life_story',
    value: 0,
    url: 'life-story',
    content: 'life_story_content',
    bgcolor: '#FED9D1',
    color: '#B97B6E',
    icon: '/icons/lifeStory.svg',
    position: 'center',
  },
  {
    title: 'Wedding Story',
    value: 1,
    url: 'classmates-story',
    content: 'classmates_story_content',
    bgcolor: '#0072CE',
    color: '#D8E8F6',
    icon: '/icons/wedding.svg',
    position: 'right',
  },
  {
    title: 'Retirement Story',
    value: 2,
    url: 'teammates-story',
    content: 'teammates_story_content',
    bgcolor: '#89D3FF',
    color: '#0072CE',
    icon: '/icons/retirement.svg',
    position: 'left',
  },
  {
    title: 'Classmates Story',
    value: 3,
    bgcolor: '#F1E0FF',
    color: '#8C58B8',
    icon: '/icons/classmate.svg',
    position: 'center',
  },
  {
    title: 'Teammates Story',
    value: 4,
    bgcolor: '#FED9D1',
    color: '#B97B6E',
    icon: '/icons/teammate.svg',
    position: 'center',
  },
  {
    title: 'Tribute Story',
    value: 5,
    bgcolor: '#0072CE',
    color: '#D8E8F6',
    icon: '/icons/tribute.svg',
    position: 'center',
  },
];

const StoryCreationModal: FC = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const [actualStoryContent, setActualStoryContent] = useState('');
  const createData = useSelector(storySelector);
  const [actualStory, setActualStory] = useState(-1);
  const isMobile = useMediaQuery((template: Theme) => template.breakpoints.down('md'));
  const isOpen = router.query?.story === 'create';
  const setStory = (item: any) => {
    setActualStory(item?.value);
    dispatch(setCreateStep(1));
    setActualStoryContent(item?.content);
    dispatch(setCreateSection(item?.text));
  };
  const handleClose = () => {
    return !isOpen;
  };

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Box
        sx={{
          width: '100vw',
          height: '100vh',
          overflow: 'auto',
          bgcolor: '#212d6dE5',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          p: 4,
        }}>
        <Box
          width={'100%'}
          maxWidth={'1110px'}
          my={'10rem'}
          alignItems={'center'}
          justifyContent={'center'}
          margin={'0 auto'}>
          {/* Close Button */}
          <IconButton onClick={handleClose} sx={{ position: 'absolute', top: 16, left: '22rem', color: 'white' }}>
            <Image priority src='/icons/close.svg' width={20} height={20} alt='close' />
          </IconButton>

          {/* Content */}
          <Box>
            <Typography fontSize={'1.3rem'} sx={{ mb: 2, color: '#F1F7FA' }}>
              Create a Memvy
            </Typography>
            <Box
              sx={{
                p: 3,
                borderRadius: '10px',
                width: '100%',
                maxWidth: '350px',
                textAlign: 'left',
                background: 'linear-gradient(92.44deg, #0171CE 6.58%, #3E44C2 89.27%)',
                color: 'white',
                cursor: 'pointer',
                fontWeight: 400,
              }}>
              <Typography lineHeight={'2rem'} fontSize={'1.6rem'}>
                Custom <br /> Story
              </Typography>
            </Box>
            <Typography fontSize={'0.9rem'} sx={{ my: 2, color: '#F1F7FA' }}>
              or use a template to get inspired
            </Typography>

            <Box
              width={'100%'}
              sx={{
                display: 'grid',
                gridTemplateColumns: isMobile ? 'repeat(1, minmax(100px, 1fr))' : 'repeat(3, minmax(100px, 1fr))',
                gap: 4,
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              {templates.map((item: any) => (
                <Box
                  onClick={() => setStory(item)}
                  key={item?.title}
                  sx={{
                    p: 3,
                    borderRadius: '10px',
                    width: '100%',
                    maxWidth: '350px',
                    textAlign: 'left',
                    background: item?.bgcolor,
                    backgroundImage: `url(${item?.icon})`,
                    backgroundSize: 'contain',
                    backgroundPosition: item?.position,
                    backgroundRepeat: 'no-repeat',
                    cursor: 'pointer',
                    fontWeight: 400,
                  }}>
                  <Typography lineHeight={'2rem'} fontSize={'1.6rem'} color={item?.color}>
                    {item?.title.split(' ').map((word: any, index: any) => (
                      <span key={index}>
                        {word}
                        <br />
                      </span>
                    ))}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default StoryCreationModal;
